const initialState = {
  drawerOpen: true,
}

const uiReducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case 'DRAWER_OPEN':
      newState.drawerOpen = true

      return newState
    case 'DRAWER_CLOSE':
        newState.drawerOpen = false
  
        return newState
    default:
      return state
  }
}

export default uiReducer
